<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Qr Code</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <router-link to="/banner">Banner Details</router-link>/
      <b>QR Code</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Card -->
        <div class="card">
          <div class="card-body" style="margin: auto;">
            <div class="text-center">
              <a
                class="btn btn-primary text-white pull-left"
                @click="download()"
                id="downloadQR"
                href="#"
              >
                Download QR Code
              </a>
            </div>

            <hr />

            <!-- Print Area -->
            <div id="printQr">
              <h1 class="text-center">
                <b style="text-transform: uppercase;">{{ active.name }}</b>
              </h1>

              <h4 class="text-center">Use Takaful Brunei Mobile App to scan</h4>

              <input id="qrtext" type="hidden" v-model="qr_string" />
              <br />

              <div style="padding: 0px 50px 0px 50px">
                <div
                  id="qrcode"
                  class="text-center"
                  style="margin: auto;"
                ></div>

                <div class="text-right">
                  <img
                    class="logo"
                    src="@/assets/images/takaful.png"
                    alt
                    width="80%"
                  />
                </div>
              </div>
            </div>
            <!-- End of print area -->
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "vendor-products",
  components: {},

  data() {
    return {
      active: [],
      pending: [],
      id: "",
      active_src: "",
      pending_src: "",
      qr_string: "",
      qr_status: 0,
      isAdmin: false
    };
  },

  methods: {
    download() {
      var element = $("#printQr"); // global variable
      var getCanvas; // global variable

      html2canvas(element, {
        onrendered: function(canvas) {
          getCanvas = canvas;
          var imgageData = getCanvas.toDataURL("image/png");
          // Now browser starts downloading it instead of just showing it
          var newData = imgageData.replace(
            /^data:image\/png/,
            "data:application/octet-stream"
          );
          $("#downloadQR")
            .attr("download", "qrcode.png")
            .attr("href", newData);
        }
      });
    },

    loadVendor() {
      let token = localStorage.getItem("token");
      let user = JSON.parse(localStorage.getItem("user"));
      let urlParams = new URLSearchParams(window.location.search);

      let user_id = 0;
      if (urlParams.has("user")) {
        user_id = urlParams.get("user");
      } else {
        user_id = user.id;
      }

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/vendor/" + user_id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.active = urlParams.has("user")
              ? res.data.vendor
              : res.data.vendor[0];
            this.id = this.active.id;
            this.qr_string = this.active.qr_string;
          })
          .then(ok => {
            this.makeCode();
          });
      }
    },

    makeCode() {
      //   let qrcode = new QRCode("qrcode");
      var qrcode = new QRCode("qrcode", {
        text: "http://jindo.dev.naver.com/collie",
        width: 500,
        height: 500,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });

      if (this.qr_string == null || this.qr_string == "") {
        swal({
          icon: "warning",
          title: "Warning",
          text: "No QR String generated"
        });

        return;
      }

      qrcode.makeCode(this.qr_string);
      console.log("QR Generated");
    }
  },

  mounted() {
    this.loadVendor();
  }
};
</script>
